exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-97ce4a76] .el-tabs__header{margin-bottom:0}", ""]);

// exports
